import type { ChangeEvent, Ref } from 'react';
import { classNames } from '@library/utils';
import { forwardRef } from 'react';

export interface TextAreaProps extends React.ComponentPropsWithRef<'textarea'> {
  className?: string;
  labelClassName?: string;
  labelName?: string;
  onValueChange: (value: string) => void;
}

const CustomTextArea = (
  {
    className = '',
    id,
    labelClassName = 'text-xs rounded-md uppercase leading-6 text-soClean-100',
    labelName = '',
    onValueChange,
    ...rest
  }: TextAreaProps,
  ref: Ref<HTMLTextAreaElement>
) => {
  const handleOnChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
    onValueChange(event.target.value);
  };

  return (
    <>
      {labelName && (
        <label htmlFor={id} className={labelClassName}>
          {labelName}
        </label>
      )}
      <textarea
        id={id}
        className={classNames(
          'bg-soFresh-110 text-soClean-100 border-soFresh-140 placeholder:text-soClean-140 block w-full rounded-md border py-1.5 sm:text-sm sm:leading-6',
          className
        )}
        onChange={handleOnChange}
        ref={ref}
        {...rest}
      />
    </>
  );
};

export const TextArea = forwardRef(CustomTextArea);
